'use strict';

const AppStore = function AppStore (APP_DISPATCHER_ID, Flux, AppActions) {
  const Store = Flux.Store.create({
    name: 'AppStore',
    events: {
      CheckCompleteSignIn: true,
      DisplayGrowl: true
    }
  });

  Store.init = () => {

    const dispatcher = Flux.Dispatcher.get(APP_DISPATCHER_ID);

    dispatcher.register(AppActions.CheckCompleteSignIn, this._handleCheckCompleteSignIn);
    dispatcher.register(AppActions.DisplayGrowl, this._handleDisplayGrowl);
  };

  this._handleCheckCompleteSignIn = () => {

    Store.emit(Store.Events.CheckCompleteSignIn);
  };

  this._handleDisplayGrowl = (ev) => {

    Store.emit(Store.Events.DisplayGrowl, ev.text, ev.config);
  };

  return Store;
};

AppStore.$inject = ['APP_DISPATCHER_ID', 'sbFlux', 'AppActions'];

module.exports = AppStore;



// WEBPACK FOOTER //
// ./src/app/AppStore.js